"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractCompanyFromFlightNumber = void 0;
const extractCompanyFromFlightNumber = (flightNumber) => flightNumber.split(" ")[0];
exports.extractCompanyFromFlightNumber = extractCompanyFromFlightNumber;
